/*! JointJS+ v4.0.1 - HTML5 Diagramming Framework - TRIAL VERSION

Copyright (c) 2024 client IO

 2024-10-28


This Source Code Form is subject to the terms of the JointJS+ Trial License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import * as joint from '@joint/plus';

export class ToolbarService {

    toolbar: joint.ui.Toolbar;

    create(commandManager: joint.dia.CommandManager, paperScroller: joint.ui.PaperScroller, readonly: boolean) {
        const { tools, groups } = this.getToolbarConfig(readonly);

        this.toolbar = new joint.ui.Toolbar({
            groups,
            tools,
            autoToggle: true,
            references: {
                paperScroller: paperScroller,
                commandManager: commandManager
            }
        });

      ///this.toolbar.getWidgetByName('undo').disable();
    }

    getToolbarConfig(readonly: boolean) {
        let tools: any = [
          {
            type: 'label',
            group: 'zoom',
            text: 'Zoom:',
            attrs: {

            }
          },
          {
            type: 'zoom-slider',
            name: 'zoom-slider',
            group: 'zoom'
          },
        ];

        if (!readonly) {
          tools.push(
            {
              type: 'undo',
              name: 'undo',
              text:  'Annuler',
              group: 'undo-redo-clear',
              attrs: {
                button: {
                  id: 'undo-button',
                  'data-tooltip': 'Annuler la dernière modification',
                  'data-tooltip-position': 'top',
                  'data-tooltip-position-selector': '.toolbar-container'
                }
              },
            },
            {
              type: 'redo',
              name: 'redo',
              text:  'Rétablir',
              group: 'undo-redo-clear',
              attrs: {
                button: {
                  id: 'redo-button',
                  'data-tooltip': "Rétablir le diagramme d'avant",
                  'data-tooltip-position': 'top',
                  'data-tooltip-position-selector': '.toolbar-container',
                }
              }
            },
            {
              type: 'button',
              name: 'clear',
              text:  'Vider le diagramme',
              group: 'undo-redo-clear',
              attrs: {
                button: {
                  id: 'btn-clear',
                  'data-tooltip': "Vider l'ensemble du diagramme",
                  'data-tooltip-position': 'top',
                  'data-tooltip-position-selector': '.toolbar-container'
                }
              }
            })
        }
        return {

            groups: {
                'undo-redo-clear': { index: 1 },
                'zoom': { index: 2 },
            },

            tools
        };
    }

}
